import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import PullQuote from "@/components/PullQuote";
import Principles from "@/components/Principles";
import SovereignStack from "@/components/SovereignStack";
import FamilyOfficePanel from "@/components/FamilyOfficePanel";
import GccOffshore from "@/components/GccOffshore";
import WhoWeServe from "@/components/WhoWeServe";
import WhatWeAreNot from "@/components/WhatWeAreNot";
import MediaSection from "@/components/MediaSection";
import Testimonials from "@/components/Testimonials";
import ContactForm from "@/components/ContactForm";
import OurStory from "@/components/OurStory";
import ExitIntentPopup from "@/components/ExitIntentPopup";
import Footer from "@/components/Footer";
import BlogPage from "@/pages/BlogPage";
import FAQPage from "@/pages/FAQPage";
import PrivacyPage from "@/pages/PrivacyPage";
import ManifestoPage from "@/pages/ManifestoPage";

function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <PullQuote />
      <Principles />
      <SovereignStack />
      <FamilyOfficePanel />
      <GccOffshore />
      <WhoWeServe />
      <WhatWeAreNot />
      <MediaSection />
      <Testimonials />
      <ContactForm />
      <OurStory />
    </>
  );
}

function App() {
  useEffect(() => {
    document.title = "Global Citizen Consulting | Jurisdictional Strategy";
  }, []);

  return (
    <div className="min-h-screen bg-[#f7f6f3]">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/manifesto" element={<ManifestoPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <ExitIntentPopup />
    </div>
  );
}

export default App;
